export default {
	headers: {
		general: {
			patient: "Patient",
			options: "Options",
			attach: "Attach",
			alert_history: "Alert history",
			resume: "Resume",
			readings: "Readings",
			notifications: "Notifications",
			report: "Report",
			reports: "Reports",
			attach_device: "Attach device",
			reading: "Reading",
			position: "Position",
			zone: "Zone",
			pillbox: "Pill box",
			add_pill: "Add pill",
			appointment: "Appointment",
			add_appointment: "Add appointment",
			edit_pill: "Edit pill",
			healthreports: "Health reports",
			medicaldocuments: "Medical documents",
			edit_configs: "Edit configurations",
			history: "History",
			response: "Response",
			watch_profile: "Patient Profile",
			add_contact: "Add contact",
			disease: "Disease",
		}
	}
}



// WEBPACK FOOTER //
// ./src/i18n/headers/headers_en-gb.js